import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
};

const contextMenuSlice = createSlice({
  name: 'contextMenu',
  initialState,
  reducers: {
    toggleContextMenu: (state, {payload}) => {
      state.isOpen = payload;
    },
  },
});

export const { toggleContextMenu } = contextMenuSlice.actions;
export default contextMenuSlice.reducer;
